import React, {useState, useEffect} from 'react';
import DatePicker from "react-datepicker";
import AddRow from './add-row.js';
import {callback} from '../../helpers.js';
import api from '../../api/index.js';

let data = {'task': false, 'hours': 0, 'field': ''};

export default (props) => {
	const [date, setDate] = useState(props.date || new Date());
	const [reloadkey, setReloadkey] = useState(0);

	const onDateChange = (d) => {
		setDate(d);
	}

	const onDataChanged = (prop, value) => {
		data[prop] = value;
		setReloadkey(reloadkey+1);
	}

	const saveData = async (e) => {
		e.preventDefault();

		if (!data.hasOwnProperty('employee'))
			return api.error("Please select an employee.");

		if (data['task'] === false) {
			return api.error("Please select a task.");
		}

		if (data['task']['TaskID'] != 5 && data['task']['TaskID'] != 6) {
			if (data['field'] == "" || data['field'] === false) {
				return api.error("Please select a field.");
			}
		}
	
		if (parseFloat(data['hours']) == 0) {
			return api.error("Please enter how many hours the employee worked.");
		}

		try {
			let response = await api.post('attendance', {'data': JSON.stringify([{'date': date, ...data}])});
			data = {'task': false, 'hours': 0, 'field': ''};
			callback(props.onAdded, []);
		} catch(e) {
			api.handleExceptions(e);
		};
	}

	useEffect(() => {
		if (reloadkey === 0) {
			data = {'task': false, 'hours': 0, 'field': ''};
			setReloadkey(reloadkey+1);
		}
	});

	return <>
		<DatePicker
			className="Date"
			selected={date}
			onChange={onDateChange}
		/>
		<AddRow {...data} date={date} reloadkey={reloadkey} onChange={onDataChanged}/>
		<button className="block" onClick={saveData}>Add entry</button>
	</>
	
}